import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import useAsyncFn from 'react-use/lib/useAsyncFn';
import { unreachable } from '../unreachable';
import { getCampusTriggerByModelTag, getModelTag } from './utils';
export var GptStreamError = /*#__PURE__*/function (_Error) {
  _inherits(GptStreamError, _Error);

  var _super = _createSuper(GptStreamError);

  function GptStreamError(message) {
    var _this;

    _classCallCheck(this, GptStreamError);

    _this = _super.call(this, message);
    _this.name = 'GptStreamError';
    return _this;
  }

  return GptStreamError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var useStreamPrediction = function useStreamPrediction(_ref) {
  var aiAssistantProps = _ref.aiAssistantProps,
      messageType = _ref.messageType,
      setStreamingData = _ref.setStreamingData;

  var _useAsyncFn = useAsyncFn( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var exerciseId, generatePrediction, getIsExperiment, isProductionEnvironment, modelParams, isExperiment, modelTag, triggerTag, response, reader, _yield$reader$read, done, value, lines;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (!(aiAssistantProps === undefined)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            exerciseId = aiAssistantProps.exerciseId, generatePrediction = aiAssistantProps.generatePrediction, getIsExperiment = aiAssistantProps.getIsExperiment, isProductionEnvironment = aiAssistantProps.isProductionEnvironment, modelParams = aiAssistantProps.modelParams;
            isExperiment = getIsExperiment();
            modelTag = getModelTag(isProductionEnvironment, messageType, isExperiment);
            triggerTag = getCampusTriggerByModelTag(modelTag);
            _context.next = 9;
            return generatePrediction({
              body: {
                input: modelParams,
                shouldStream: true,
                simulateStreamDelay: 30,
                trigger: {
                  _tag: triggerTag,
                  exerciseId: exerciseId
                },
                useCache: true
              },
              params: {
                modelTag: modelTag
              }
            });

          case 9:
            response = _context.sent;

            if (!(response.body != null && response.ok)) {
              _context.next = 26;
              break;
            }

            reader = response.body.getReader(); // eslint-disable-next-line no-constant-condition

          case 12:
            if (!true) {
              _context.next = 24;
              break;
            }

            _context.next = 15;
            return reader.read();

          case 15:
            _yield$reader$read = _context.sent;
            done = _yield$reader$read.done;
            value = _yield$reader$read.value;

            if (!done) {
              _context.next = 21;
              break;
            }

            setStreamingData(function (previousValue) {
              switch (previousValue.type) {
                case 'streaming':
                  if (previousValue.content == null || previousValue.id == null) {
                    return {
                      reason: 'failed-to-get-gpt-response',
                      type: 'error'
                    };
                  }

                  return {
                    content: previousValue.content,
                    id: previousValue.id,
                    type: 'ready'
                  };

                case 'initial':
                case 'ready':
                case 'error':
                  return previousValue;

                default:
                  return unreachable(previousValue);
              }
            });
            return _context.abrupt("break", 24);

          case 21:
            if (value) {
              lines = new TextDecoder('utf-8').decode(value).split('\n');
              lines.forEach(function (line) {
                if (line.trim() !== '') {
                  var gptStream = JSON.parse(line);

                  if (gptStream.type === 'gpt-error') {
                    throw new GptStreamError(gptStream.reason);
                  }

                  setStreamingData(function (previousValue) {
                    switch (previousValue.type) {
                      case 'error':
                      case 'initial':
                        return {
                          content: gptStream.type === 'gpt-partial-answer' ? gptStream.choices[0].text : undefined,
                          id: gptStream.type === 'gpt-id' ? gptStream.id : undefined,
                          type: 'streaming'
                        };

                      case 'ready':
                        return previousValue;

                      case 'streaming':
                        {
                          var newContent = gptStream.type === 'gpt-partial-answer' ? "".concat(previousValue.content ? previousValue.content : '').concat(gptStream.choices[0].text) : previousValue.content;
                          return {
                            content: newContent,
                            id: previousValue.id,
                            type: 'streaming'
                          };
                        }

                      default:
                        return unreachable(previousValue);
                    }
                  });
                }
              });
            }

            _context.next = 12;
            break;

          case 24:
            _context.next = 27;
            break;

          case 26:
            setStreamingData({
              reason: 'failed-to-get-gpt-response',
              type: 'error'
            });

          case 27:
            _context.next = 32;
            break;

          case 29:
            _context.prev = 29;
            _context.t0 = _context["catch"](0);
            setStreamingData({
              // @ts-expect-error fix later
              reason: _context.t0.message,
              type: 'error'
            });

          case 32:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 29]]);
  })), [aiAssistantProps]),
      _useAsyncFn2 = _slicedToArray(_useAsyncFn, 2),
      state = _useAsyncFn2[0],
      getPrediction = _useAsyncFn2[1];

  return {
    getPrediction: getPrediction,
    loading: state.loading
  };
};